import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Reveal } from "./Shared";
import { ArrowRight } from "lucide-react";
import { productUrl } from "@/config/siteUrls";

const CTA = () => {
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative py-32 sm:py-40 border-t forr-canvas overflow-hidden"
      style={{ borderColor: "var(--forr-line-soft)" }}
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] forr-radial-teal opacity-80" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full blur-3xl forr-breathe" style={{ backgroundColor: "rgba(15,181,166,0.14)" }} />
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
        <Reveal>
          <div className="text-center">
            <span
              data-testid="cta-overline"
              className="forr-overline"
            >
              Retrain the state. Change the behavior.
            </span>
            <h2
              data-testid="cta-heading"
              className="mt-8 font-display forr-text-ink text-4xl sm:text-5xl md:text-6xl lg:text-[80px] font-medium tracking-[-0.03em] leading-[1.02] max-w-4xl mx-auto"
            >
              Your nervous system is ready to learn something new.
            </h2>
            <p
              data-testid="cta-subheadline"
              className="mt-10 max-w-2xl mx-auto text-lg font-light forr-text-soft leading-relaxed"
            >
              The Adaptive Assessment is available now. Complete it to understand
              your nervous-system pattern, see how it may connect with daily life,
              and receive a personalized starting direction.
            </p>

            <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href={productUrl("/assessment/start")} data-testid="cta-primary-button-link">
                <motion.span
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  data-testid="cta-primary-button"
                  className="forr-btn-primary group inline-flex items-center gap-3 px-8 py-4 rounded-full text-sm font-semibold tracking-wide"
                >
                  Take the Adaptive Assessment
                  <ArrowRight
                    size={16}
                    strokeWidth={2}
                    className="transition-transform duration-300 group-hover:translate-x-1"
                  />
                </motion.span>
              </a>
              <Link
                to="/methodology"
                data-testid="cta-secondary-button"
                className="forr-btn-secondary inline-flex px-7 py-4 rounded-full text-sm font-medium tracking-wide"
              >
                Explore Adaptive Physiology
              </Link>
            </div>

            <div className="mt-16 flex items-center justify-center gap-2 text-[11px] uppercase tracking-[0.28em] forr-text-mute">
              <span
                className="w-1.5 h-1.5 rounded-full"
                style={{ backgroundColor: "var(--forr-ink-mute)" }}
              />
              Assessment open now · A methodology by FORR Health
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CTA;
